<template>
  <div class="privacy" v-bind:class="{ accepted: accepted }">
    <div class="privacy-content">
      <p>You can check our policy here: </p>
        <a href="https://di-support.com/en/legal-information/#1472644135174-c37b87bc-c276" target="_blank">Terms Policy</a><br>
        <a href="https://di-support.com/en/legal-information/#1472644135269-c6755940-2b04" target="_blank">Privacy Policy</a><br>
        <a href="https://di-support.com/en/legal-information/" target="_blank">Impressum</a>
    </div>
    <div class="privacy-close" @click="acceptCookie">
      Close
    </div>
  </div>
</template>
<script>
export default {
    name: 'privacy',
    data () {
      return {
        accepted: false
      }
    },
    methods: {
        acceptCookie(){
            localStorage.setItem('cookie', true)
            this.accepted = true
        },
    },
    created(){
      if(localStorage.getItem('cookie')){
         this.accepted = true
      }
    }
};
</script>

<style lang="scss" scoped>

.privacy {
  position: fixed;
  bottom: 0;
  background-color: white;
  display: flex;
  flex-direction: row;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
  margin-left: 15px;
  z-index: 2000;
  &.accepted {
    display: none;
  }

  &-content {

  }
  &-close {
    align-self: flex-end;
    background-color: #526d82;
    color: white;
    padding: 5px 10px;
    cursor: pointer;
  }
}
</style>
